import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import type { TellentNote } from '@tellent-ask-hr/notes-types';

export interface TellentNoteCreatePayload {
  bodyJson: object;
}

export const getTellentNoteScope = (
  resourceType: TellentNote['resourceType'],
  resourceId: number,
): string => `${resourceType}-${resourceId}`;

const idSelector = (note: { id: number }) => note.id;
const { selectors, reducer, actions, namespace } = createEntityCollectionStore<TellentNote>()(
  'TellentNotes',
  {
    idSelector,
    customActions: adapter => {
      const _defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        removeOnePessimistic: (state, payload: { id: number }) =>
          adapter.markAsPending(state, { scope: null, entities: [payload.id] }),

        updateOnePessimistic: (state, payload: { id: number; note: TellentNoteCreatePayload }) =>
          adapter.markAsPending(state, { scope: null, entities: [payload.id] }),

        createOnePessimistic: (
          state,
          payload: {
            resourceType: TellentNote['resourceType'];
            resourceId: number;
            note: TellentNoteCreatePayload;
            correlationId: string;
          },
        ) =>
          adapter.markAsPending(state, {
            scope: null,
            entities: payload.correlationId ? [payload.correlationId] : [],
          }),
        createOnePessimisticFailed: (
          state,
          payload: {
            error: Error;
            data: TellentNoteCreatePayload;
            correlationId: string;
          },
        ) =>
          adapter.setError(state, {
            scope: null,
            entities: payload.correlationId ? [payload.correlationId] : [],
            error: payload.error,
          }),

        fetchCollection: (
          state,
          payload: { resourceType: TellentNote['resourceType']; resourceId: number },
        ) =>
          adapter.markAsPending(state, {
            scope: getTellentNoteScope(payload.resourceType, payload.resourceId),
            entities: [],
          }),

        removeOnePessimisticSuccess: (state, payload: { data: { id: number } }) =>
          adapter.removeOne(state, payload.data.id),
      };
    },
  },
);

export {
  selectors as TellentNotesSelectors,
  reducer as TellentNotesReducer,
  actions as TellentNotesActions,
  namespace as TellentNotesNamespace,
};
